export default __webpack_public_path__ + "b1fd8a6f0864857e237589a83d24646b.woff2";